export function checkIfTimestampIsZero(info: Info): [Info, boolean] {
    let checked = false
    const result = Object.entries(info).reduce((previous, [key, value]) => {
        if (key.match(/(begin|end)/) && (value === '0' || value === 0)) {
            checked = true
        }

        return Object.assign(previous, {
            [key]: key.match(/(begin|end)/) && (value === '0' || value === 0) ? null : value
        })
    }, {} as Info)

    return [result, checked]
}
